<template>
  <div>
    <v-card-text>
      <v-select
        outlined
        hide-details
        dense
        label="綁定權限"
        item-text="name"
        item-value="type"
        :items="authList"
        v-model="formData.authSelected"
      ></v-select>
      <br>
      <v-autocomplete
        outlined
        hide-details
        dense
        label="會員名稱"
        item-text="name"
        item-value="id"
        :items="memberList"
        v-model="formData.memberselected"
        :filter="customFilter"
      >
        <template #item="{ on, attrs, item }">
          <v-list-item v-on="on" v-bind="attrs">
            <v-list-item-content>
              <v-list-item-title>
                <strong>{{ item.name }}</strong>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ item.created_at }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-card-text>
  </div>
</template>

<script>
export default {
  props: {
    popupConfig: Object,
  },
  data: () => ({
    formData: {
      authSelected: '',
      memberselected: ''
    }
  }),
  computed: {
    authList() {
      return this.popupConfig.authList
    },
    memberList() {
      return this.popupConfig.memberList
    },
  },
  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit('updateData', this.formData)
      },
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const name = (item.name || '').toLowerCase()
      const email = (item.email || '').toLowerCase()
      const query = (queryText || '').toLowerCase()
      return name.includes(query) || email.includes(query)
    }
  },
};
</script>